module.exports = __webpack_public_path__ + "static/card-profile6-square-1f1f4900f3bc166b75f8235c2b89864f.jpg";